module.exports = __webpack_public_path__ + "img/round-google-display.ae6e70ee.svg";